<div class="container">
  <ng-container *ngIf="showLoading">
    <div class="loader">
      <div class="loader-spinner">
        <div class="loader-shapes"></div>
      </div>
      <div class="loader-message">
        {{ 'PAGES.CAST.LOADER.MESSAGE' | translate }}
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="!showLoading">
    <ng-container *ngIf="errorPage">
      <app-cast-error
        [title]="errorTitle"
        [message]="errorMessage"
        (doBack)="doErrorBack()"
        (doClose)="doErrorClose()"></app-cast-error>
    </ng-container>
    <ng-container *ngIf="pairingPage">
      <div class="container__left">
        <div class="googlecast-image">
          <img src="assets/images/googlecast/pre_tos.svg" alt="" />
        </div>
        <div class="container__left__bottom">
          <ng-container *ngIf="roomNumber">
            <div class="room-info">
              {{ roomNumber }}
            </div>
          </ng-container>
          <div class="googlecast-logo">
            <img src="assets/images/googlecast/ic_cast_24dp_white.svg" alt="" />
            <span class="googlecast-logo__text">Google Cast</span>
          </div>
          <div class="description">
            {{ 'PAGES.CAST.PAIRING_DESCRIPTION' | translate }}
          </div>
          <div class="settings">
            <div class="settings__description">
              {{ 'PAGES.CAST.SETTINGS_AGREEMENT' | translate }}
            </div>
            <button class="settings__button htv-selectable" (click)="launchGoogleCastSettings()">
              {{ 'PAGES.CAST.SETTINGS_BUTTON' | translate }}
            </button>
          </div>
        </div>
      </div>
      <div class="container__right">
        <app-cast-qrcode></app-cast-qrcode>
      </div>
    </ng-container>
    <ng-container *ngIf="readyToCastPage">
      <div class="container__left ready-casting__left">
        <div class="ready-casting__left__content">
          <div class="ready-casting__ready">
            {{ 'PAGES.CAST.START_CASTING.READY' | translate }}
          </div>
          <div class="instruction">
            <div class="instruction__left"></div>
            <div class="instruction__right">
              <span class="instruction__text instruction__first">
                {{ 'PAGES.CAST.START_CASTING.OTHER_DEVICE' | translate }}
              </span>
            </div>
          </div>
          <div class="instruction">
            <div class="instruction__left">
              <span class="instruction__step">1</span>
            </div>
            <div class="instruction__right">
              <span class="instruction__text">
                {{ 'PAGES.CAST.START_CASTING.OTHER_DEVICE_1' | translate }}
              </span>
            </div>
          </div>
          <div class="instruction">
            <div class="instruction__left">
              <span class="instruction__step">2</span>
            </div>
            <div class="instruction__right">
              <span class="instruction__text">
                {{ 'PAGES.CAST.START_CASTING.OTHER_DEVICE_2' | translate }}
              </span>
              <div class="instruction__icon">
                <img src="assets/images/googlecast/ic_cast_24dp.svg" alt="" />
              </div>
            </div>
          </div>
          <div class="instruction">
            <div class="instruction__left">
              <span class="instruction__step">3</span>
            </div>
            <div class="instruction__right">
              <span class="instruction__text">
                <span>{{ 'PAGES.CAST.START_CASTING.OTHER_DEVICE_3a' | translate }}</span>
                <span class="instruction__text__tv-name">{{ tvName }}</span>
                <span>{{ 'PAGES.CAST.START_CASTING.OTHER_DEVICE_3b' | translate }}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="ready-casting__left__footer">
          <button class="ready-casting__button htv-selectable" (click)="done()">
            {{ 'PAGES.CAST.START_CASTING.DONE_BUTTON' | translate }}
          </button>
          <div class="separator"></div>
          <button class="ready-casting__button htv-selectable" (click)="showPairingPage()">
            {{ 'PAGES.CAST.START_CASTING.CONNECT_BUTTON' | translate }}
          </button>
        </div>
      </div>
      <div class="container__right ready-casting__right">
        <div class="ready-casting__success-image">
          <img src="assets/images/googlecast/post_tos.svg" alt="" />
        </div>
        <div class="ready-casting__cast-name">
          <mat-icon>&#xe333;</mat-icon>
          <span>{{ tvName }}</span>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
